import React from 'react'
import LoadingLogo from 'assets/images/icon_256x256.png';
import './loadingscreen.less';

const LoadinScreen = () => (
    <div class="loading-screen__wrapper">
        <div class="main-loading active">
            <img alt="medsis loading" src={LoadingLogo} class="main-loading-logo"/>
        </div>
    </div>
)

export default LoadinScreen;